import React from 'react';
import numeral from 'numeral';
import { Common } from '@stockbit/ui';

import { OrderbookIndexSummary, PriceChangeText } from './styled';
import { useOrderbookStore as wsStore } from './store';
import { getType } from 'features/company/Stream/TableOrderbook/utils';

const { Text } = Common;

const Summary = ({ symbol, lastprice, change, percentageChange }) => {
  const liveprice = wsStore(({ liveprice }) => liveprice?.[symbol]);

  const getLastPrice = () => {
    return liveprice
      ? numeral(liveprice.lastprice).format('0,0[.]00')
      : numeral(lastprice).format('0,0[.]00');
  };

  const getChangeValue = () => {
    return liveprice
      ? numeral(liveprice.change).format('0')
      : numeral(change).format('0');
  };

  const getChangePercentValue = () => {
    const result = liveprice
      ? numeral(liveprice.percentage_change).format('0.00') + '%'
      : numeral(percentageChange).format('0.00') + '%';

    return (
      <>
        <span>(</span> {result} <span>)</span>
      </>
    );
  };

  return (
    <OrderbookIndexSummary className="orderbook-title">
      <Text as="span" size="24px" family="bold" mr="5px">
        {getLastPrice()}
      </Text>
      <PriceChangeText
        as="div"
        $type={getType(liveprice ? liveprice.change : change)}
      >
        {Number(getChangeValue()) > 0 && '+'}
        {getChangeValue()} {getChangePercentValue()}
      </PriceChangeText>
    </OrderbookIndexSummary>
  );
};

export default Summary;
